import { createReducer } from '@reduxjs/toolkit'
import { increment, decrement, incrementByAmount } from './counterActions'

interface CounterState {
  value: number
}

const initialState = { value: 0 } as CounterState

export default createReducer(initialState, (builder) => {
  builder
    .addCase(increment, (state, action) => {
      state.value++
    })
    .addCase(decrement, (state, action) => {
      state.value--
    })
    .addCase(incrementByAmount, (state, action) => {
      state.value += action.payload
    })
})
